module.exports = __webpack_public_path__ + "static/alps2alps-skin-16553650051172a52ffcce9ddc9981e9.png";